import { render, staticRenderFns } from "./PachymetryForm.vue?vue&type=template&id=118e63a9"
import script from "./PachymetryForm.vue?vue&type=script&lang=js"
export * from "./PachymetryForm.vue?vue&type=script&lang=js"
import style0 from "./PachymetryForm.vue?vue&type=style&index=0&id=118e63a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports